import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { apiFetch } from '../lib/api'

export default function BlogsPage() {
  const [blogs, setBlogs] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    document.title = 'Blogs - Co-Eater'
  }, [])

  useEffect(() => {
    let mounted = true

    async function loadBlogs() {
      try {
        const res = await apiFetch('/blogs?limit=50')
        const data = await res.json()
        if (!res.ok) throw new Error(data.message || 'Failed to load blogs.')
        if (mounted) setBlogs(data)
      } catch (err) {
        if (mounted) setError(err.message || 'Failed to load blogs.')
      } finally {
        if (mounted) setLoading(false)
      }
    }

    loadBlogs()
    return () => {
      mounted = false
    }
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50 px-4 py-6 sm:px-8">
      <div className="mx-auto max-w-5xl">
        <header className="rounded-3xl border border-orange-100 bg-white/80 p-6 shadow-sm">
          <a href="/" className="text-xs font-bold uppercase tracking-[0.2em] text-orange-600">Co-Eater</a>
          <h1 className="mt-2 title-font text-3xl font-extrabold text-gray-900">Blogs</h1>
          <p className="mt-2 text-sm text-gray-600">Explore all published stories, updates, and food tips.</p>
        </header>

        {loading && (
          <div className="mt-6 rounded-3xl border border-orange-100 bg-white/80 p-6 text-center text-sm text-gray-600 shadow-sm">
            Loading blogs...
          </div>
        )}

        {!loading && error && (
          <div className="mt-6 rounded-3xl border border-red-100 bg-white/80 p-6 text-center text-sm text-red-600 shadow-sm">
            {error}
          </div>
        )}

        {!loading && !error && blogs.length === 0 && (
          <div className="mt-6 rounded-3xl border border-orange-100 bg-white/80 p-6 text-center text-sm text-gray-600 shadow-sm">
            No blogs published yet.
          </div>
        )}

        {!loading && !error && blogs.length > 0 && (
          <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {blogs.map((blog) => (
              <Link
                key={blog.id}
                to={`/blogs/${blog.slug}`}
                className="overflow-hidden rounded-2xl border border-orange-100 bg-white/80 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md"
              >
                {blog.imageUrl && (
                  <img src={blog.imageUrl} alt={blog.title} className="h-44 w-full object-cover" />
                )}
                <div className="p-4">
                  <h2 className="text-base font-bold text-gray-900 line-clamp-2">{blog.title}</h2>
                  {blog.excerpt && <p className="mt-2 text-sm text-gray-600 line-clamp-3">{blog.excerpt}</p>}
                  <p className="mt-3 text-xs text-gray-500">
                    {blog.author || 'Co-Eater Team'}
                    {' · '}
                    {blog.publishedAt
                      ? new Date(blog.publishedAt).toLocaleDateString()
                      : new Date(blog.createdAt).toLocaleDateString()}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
